import { useNavigate, Outlet } from "react-router-dom";
import { useState } from "react";

import "../css/font-awesome-pro.css";
import logo from "../images/minda-logo.png";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import {Typography,Stack} from "@mui/material";


import { Fade, InputAdornment, IconButton } from '@mui/material';

import { changePassword } from "../api";

  
  const navActionStyles = {
    minWidth: 0,
    color: "#6b7280",
    "&.Mui-selected": {
      color: "#2563eb"
    },
    "&.Mui-selected::before": {
      content: '""',
      position: "absolute",
      top: 6,
      width: 24,
      height: 3,
      borderRadius: 2,
      backgroundColor: "#2563eb"
    }
  };


function Home() {
  const navigate = useNavigate();

  /* ================= STATE ================= */
  const [showChangePwd, setShowChangePwd] = useState(false);
  const [formData, setFormData] = useState({ pwd: "", cPwd: "" });
  const [formErr, setFormErr] = useState({ pwd: "", cPwd: "" });

  /* ================= HANDLERS ================= */
  const updateForm = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
    setFormErr(prev => ({ ...prev, [key]: "" }));
  };

  const submitChangePassword = () => {
    const { pwd, cPwd } = formData;
    const errors = {};

    if (!pwd) errors.pwd = "Required";
    if (!cPwd) errors.cPwd = "Required";
    if (pwd && pwd.length < 8) errors.pwd = "Minimum 8 characters";
    if (pwd && !/[A-Z]/.test(pwd)) errors.pwd = "Must contain capital letter";
    if (pwd && !/[a-z]/.test(pwd)) errors.pwd = "Must contain small letter";
    if (pwd && !/[0-9]/.test(pwd)) errors.pwd = "Must contain number";
    if (pwd && cPwd && pwd !== cPwd) errors.cPwd = "Passwords do not match";

    if (Object.keys(errors).length) {
      setFormErr(errors);
      return;
    }

    changePassword(formData).then(resp => {
      alert(resp?.message || "Something went wrong");
      if (resp?.success) {
        setShowChangePwd(false);
        setFormData({ pwd: "", cPwd: "" });
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ================= HEADER ================= */}
      <header className="bg-white border-b border-gray-200">
        <div className="flex items-center justify-between px-6 py-3">
          {/* LOGO + ALL DEVICES */}
          <div className="flex items-center gap-6">
            <img src={logo} alt="Logo" className="h-9 object-contain" />

            <ListItem disablePadding  sx={{
            display: { xs: "none", md: "inline-flex" },
            fontWeight: 700
          }}>
              <ListItemButton
                onClick={() => navigate("/devices")}
                sx={{
                  px: 2,
                  py: 1,
                  borderRadius: 1.5,
                  border: "1px solid #e5e7eb", // gray-200
                  backgroundColor: "#2563eb", // blue-600
                  color: "#ffffff",          // white text + icon

                  "&:hover": {
                    backgroundColor: "#1d4ed8" // blue-700
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 36,
                    color: "inherit" // inherits white from button
                  }}
                >
                  <i className="fa-solid fa-home" />
                </ListItemIcon>

                <ListItemText
                  primary="All Devices"
                  primaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: 500
                  }}
                />
              </ListItemButton>
            </ListItem>
          </div>

           <div className="flex items-center gap-3">
            <Button className="font-bold"
            
            sx={{
            display: { xs: "none", md: "inline-flex" },
            fontWeight: 700
          }}

size="medium" onClick={() => setShowChangePwd(true)}>
              Change Password
            </Button>
            <span className="text-gray-300">|</span>
            <Button
              size="small"
              onClick={() => {
                sessionStorage.clear();
                navigate("/", { replace: true });
              }}
            >
              <i className="fa-solid fa-right-from-bracket"></i>
            </Button>
          </div>
          </div>
          </header>

          <Paper
            elevation={0}
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              display: { xs: "block", md: "none" },
              borderTop: "1px solid #e5e7eb",
              zIndex: 1300,
              backgroundColor: "#fff"
            }}
          >
            <BottomNavigation sx={{ height: 60 }}>
              <BottomNavigationAction
                label="Devices"
                icon={
                  <Stack spacing={0.3} alignItems="center">
                    <i className="fa-solid fa-desktop text-lg" />
                    <Typography fontSize={11}>Devices</Typography>
                  </Stack>
                }
                onClick={() => navigate("/devices")}
                sx={navActionStyles}
              />

             <BottomNavigationAction
                label="Change Password"
                icon={
                    <Stack spacing={0.3} alignItems="center">
                      <i className="fa-solid fa-key text-lg" />
                      <Typography fontSize={11}>Change Password</Typography>
                    </Stack>
                }
                onClick={() => setShowChangePwd(true)}
                sx={navActionStyles}
              />

            </BottomNavigation>
          </Paper>



      <div className="flex">
        
        {/* MAIN CONTENT */}
        <main className="flex-1 p-1 md:p-6 overflow-auto !mb-20">
        

          <Outlet />
        </main>
      </div>

          {/* ================= CHANGE PASSWORD MODAL ================= */}
      <Modal 
        open={showChangePwd} 
        onClose={() => setShowChangePwd(false)}
        closeAfterTransition
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              backdropFilter: 'blur(4px)'
            }
          }
        }}
      >
        <Fade in={showChangePwd}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90vw", sm: "80vw", md: 500 },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              borderRadius: 3,
              boxShadow: "0 24px 48px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column"
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 3,
                pb: 2,
                borderBottom: 1,
                borderColor: "divider",
                bgcolor: "background.default"
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 2,
                      bgcolor: "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "primary.contrastText"
                    }}
                  >
                    <i className="fa-solid fa-lock" style={{ fontSize: 18 }} />
                  </Box>
                  <Box>
                    <Typography variant="h6" fontWeight={600}>
                      Change Password
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Update your account password
                    </Typography>
                  </Box>
                </Stack>

                <IconButton
                  onClick={() => setShowChangePwd(false)}
                  sx={{
                    color: "text.secondary",
                    "&:hover": { 
                      bgcolor: "action.hover",
                      color: "text.primary" 
                    }
                  }}
                >
                  <i className="fa-solid fa-xmark" style={{ fontSize: 20 }} />
                </IconButton>
              </Stack>
            </Box>

            {/* Form */}
            <Box
              sx={{
                p: 3,
                overflowY: "auto",
                flex: 1
              }}
            >
              <Stack spacing={2.5}>
                <TextField
                  fullWidth
                  label="New Password"
                  type="password"
                  placeholder="Enter new password"
                  value={formData.pwd}
                  onChange={e => updateForm("pwd", e.target.value)}
                  error={!!formErr.pwd}
                  helperText={formErr.pwd}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <i 
                          className="fa-solid fa-key" 
                          style={{ fontSize: 14, color: '#666' }}
                        />
                      </InputAdornment>
                    )
                  }}

                  sx={{
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0
          },
          '& input[type=number]': {
            MozAppearance: 'textfield'
          },
          '& .MuiInputLabel-outlined': {
            transform: 'translate(48px, 16px) scale(1)', // Increased from 14px to 48px for icon space
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -9px) scale(0.75)',
              backgroundColor: 'background.paper',
              padding: '0 4px'
            }
          }
        }}
                />

                <TextField
                  fullWidth
                  label="Confirm Password"
                  type="password"
                  placeholder="Re-enter new password"
                  value={formData.cPwd}
                  onChange={e => updateForm("cPwd", e.target.value)}
                  error={!!formErr.cPwd}
                  helperText={formErr.cPwd}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <i 
                          className="fa-solid fa-shield-halved" 
                          style={{ fontSize: 14, color: '#666' }}
                        />
                      </InputAdornment>
                    )
                  }}

                  sx={{
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0
          },
          '& input[type=number]': {
            MozAppearance: 'textfield'
          },
          '& .MuiInputLabel-outlined': {
            transform: 'translate(48px, 16px) scale(1)', // Increased from 14px to 48px for icon space
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -9px) scale(0.75)',
              backgroundColor: 'background.paper',
              padding: '0 4px'
            }
          }
        }}
                />

                {/* Password Requirements */}
                <Box
                  sx={{
                    p: 2,
                    bgcolor: "info.lighter",
                    borderRadius: 2,
                    border: 1,
                    borderColor: "info.light"
                  }}
                >
                  <Stack direction="row" alignItems="flex-start" spacing={1}>
                    <i 
                      className="fa-solid fa-circle-info" 
                      style={{ fontSize: 14, color: '#0288d1', marginTop: 2 }}
                    />
                    <Box>
                      <Typography variant="caption" fontWeight={600} color="info.dark">
                        Password Requirements:
                      </Typography>
                      <Typography variant="caption" display="block" color="text.secondary">
                        • Minimum 8 characters
                      </Typography>
                      <Typography variant="caption" display="block" color="text.secondary">
                        • Include uppercase and lowercase letters
                      </Typography>
                      <Typography variant="caption" display="block" color="text.secondary">
                        • Include at least one number
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Stack>
            </Box>

            {/* Footer Actions */}
            <Box
              sx={{
                p: 3,
                pt: 2,
                borderTop: 1,
                borderColor: "divider",
                bgcolor: "background.default"
              }}
            >
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button
                  size="large"
                  variant="outlined"
                  onClick={() => setShowChangePwd(false)}
                  sx={{ 
                    minWidth: 120,
                    borderColor: "divider",
                    color: "text.secondary",
                    "&:hover": {
                      borderColor: "text.secondary",
                      bgcolor: "action.hover"
                    }
                  }}
                  startIcon={<i className="fa-solid fa-xmark" />}
                >
                  Cancel
                </Button>
                <Button
                  size="large"
                  variant="contained"
                  onClick={submitChangePassword}
                  startIcon={<i className="fa-solid fa-check" />}
                  sx={{ 
                    minWidth: 120,
                    boxShadow: 2,
                    "&:hover": {
                      boxShadow: 4
                    }
                  }}
                >
                  Update Password
                </Button>
              </Stack>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default Home;
